import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { deleteUser, getUserData } from "../services/userAPI";
import AppMenu from "../components/AppMenu";
import { Table } from "reactstrap";
import { title } from "../config";
import { userActiveInactive, userRoles } from "../services/constant";
import { BackButton } from "../components/BackButton";
import { useToast } from "../components/ToastContext";
import '../assets/css/User.css';


export function User() {
  const navigate = useNavigate();
  const { showToast } = useToast();
  const [items, setItems] = useState([]);

  useEffect(() => {
    reloadUser();
  }, []);

  const reloadUser = async () => {
    let records = await getUserData(showToast);
    setItems(records);
  };
  const doDelete = async (data) => {
  try {
    const result = await deleteUser(data, showToast);

    if (result?.result === "success") {
      showToast(result?.msg ?? "User deleted successfully!", "success");
    } else {
      showToast(result?.msg ?? "Failed to delete user", "error");
    }

    reloadUser(); 
  } catch (error) {
    showToast("An error occurred while deleting the user", "error");
  }
};

  const doEdit = (id) => {
    navigate(`/user/edit/${id}`);
  };
  return (
    <div className="user-page">
      <div className="px-2 sticky-header">
        <h3 className="m-0 p-2">{title} | Users</h3>
        <AppMenu title="Users" />
      </div>
      <BackButton icon="←" />
      <span className="headerMargin">{getAddButton(navigate)}</span>
      <UserList items={items} doDelete={doDelete} doEdit={doEdit} />
    </div>
  );
}

const getStatus = (status) => {
  let statusData = userActiveInactive.find((item) => item.value == status);
  if (statusData) {
    return statusData.name;
  } else {
    return "";
  }
};
const getRole = (role) => {
  let roleData = userRoles.find((item) => item.value == role);
  if (roleData) {
    return roleData.name;
  } else {
    return "";
  }
};
const getAddButton = (navigate) => {
  return (
    <button
      className="fa-sharp fa-plus btn btn-primary"
      onClick={() => {
        navigate("/user/add");
      }}
      variant="contained"
    >
      Add
    </button>
  );
};

function UserList({ items, doDelete, doEdit }) {
  return (
    <div className="user-container">
      <Table>
        <thead>
          <tr>
            <th></th>
            <th>Sr. No.</th>
            <th>Name</th>
            <th>Email</th>
            {/* <th>Phone</th> */}
            <th>Active</th>
            <th>Last Login</th>
            <th>Role </th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {items.length > 0 &&
            items.map((item, index) => (
              <tr key={item._id}>
                <td></td>
                <td>{index+1}</td>
                <td>{item.name}</td>
                <td>{item.email}</td>
                {/* <td>{item.phone || '-'}</td> */}
                <td>{getStatus(item.active)}</td>
                <td>
                  {item.lastLogin
                    ? new Date(item.lastLogin).toLocaleString("en-GB", {
                      timeZone: "Asia/Kolkata", 
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: true,
                    })
                    : "—"}
                </td>
                <td>{getRole(item.role)}</td>
                <td className="d-flex">
                  <i
                    className="fas fa-edit btn btn-primary m-2"
                    onClick={() => doEdit(item._id)}
                    aria-hidden="true"
                  />
                  <i
                    className="fa-solid fa-trash-can btn btn-danger m-2"
                    onClick={() => doDelete(item._id)}
                    aria-hidden="true"
                  />
                </td>
              </tr>
            ))}
        </tbody>
      </Table>
    </div>
  );
}
